import ButtonRound from "../ButtonRound/ButtonRound";
import "./ButtonRoundContainer.scss";

import cross from "../../assets/images/Cross.png";
import tick from "../../assets/images/Tick.png";

const ButtonRoundContainer = ({ handleCorrect, handleIncorrect }) => {
  return (
    <div className="button-round-container">
      <ButtonRound
        onClick={handleIncorrect}
        iconImg={cross}
        alt="cross"
        backgroundColor="#f27b39"
        backgroundColorHover="#ee9260"
      />
      <ButtonRound
        onClick={handleCorrect}
        iconImg={tick}
        alt="tick"
        backgroundColor="#7dc833"
        backgroundColorHover="#abe76e"
      />
    </div>
  );
};

export default ButtonRoundContainer;
